import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TaskLocation } from '@ml/tasks/types/classes/task-location.class';
import { Task } from '@ml/tasks/types/classes';
import { FormControl, Validators } from '@angular/forms';
import { TaskLocationStatus } from '@ml/tasks/types/enums/task-location-status.enum';
import { TaskLocationService } from '@ml/tasks/services/task-location.service';
import { finalize } from 'rxjs/operators';
import { User } from '@ml/core/types/classes';

@Component({
  selector: 'ml-order-location-status-dialog',
  template: `
    <div class="container">
      <div class="mat-title">
        {{ 'task-location-status' | translate | titlecase }}
      </div>

      <div fxLayout="column" fxLayoutGap="16px">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div class="label mat-body-2">
            {{ 'task' | translate | titlecase }}:
          </div>
          <div class="mat-body-2">{{ data.task.name }}</div>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
          <div class="label mat-body-2">
            {{ 'employee' | translate | titlecase }}:
          </div>
          <div class="mat-body-2">{{ employeeName || '-' }}</div>
        </div>

        <ml-select
          [label]="'status'"
          [filterable]="false"
          [options]="statuses"
          [translate]="true"
          [clear]="false"
          [control]="statusControl"
        ></ml-select>
      </div>

      <ml-dialog-actions
        [disable]="statusControl.invalid || loading"
        (clickLeft)="onClose()"
        (clickRight)="onSave()"
      ></ml-dialog-actions>
    </div>
  `,
  styleUrls: ['./order-location-status-dialog.component.scss']
})
export class OrderLocationStatusDialogComponent implements OnInit {
  loading: boolean;
  statusControl = new FormControl('', Validators.required);
  statuses = Object.values(TaskLocationStatus).map(value => ({
    id: value,
    name: value
  }));

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      task: Task;
      taskLocation: TaskLocation;
    },
    private dialogRef: MatDialogRef<OrderLocationStatusDialogComponent>,
    private taskLocationService: TaskLocationService
  ) {}

  ngOnInit() {
    this.statusControl.setValue(this.data.taskLocation.status);
  }

  get employeeName() {
    if (this.data.task.employee) {
      return (this.data.task.employee as User).name;
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  onSave() {
    this.loading = true;
    this.data.taskLocation.status = this.statusControl.value;
    this.taskLocationService
      .setStatus(this.data.taskLocation)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(taskLocation => {
        this.data.taskLocation = taskLocation;
        this.dialogRef.close(taskLocation);
      });
  }
}
